import React from "react";
import { FaXmark, FaFolderOpen } from "react-icons/fa6";

function ComingSoonModal({ isOpen, onClose, projectTitle }) {
  if (!isOpen) return null;

  return (
    /* 1. Tambahkan onClick={onClose} pada overlay background paling luar 
         untuk mendeteksi klik di luar modal.
    */
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-200"
    >
      {/* 2. Tambahkan onClick={(e) => e.stopPropagation()} pada kontainer modal utama.
           Ini wajib supaya ketika kita mengklik isi di dalam modal, modal TIDAK ikut tertutup.
      */}
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md border-4 border-slate-900 bg-white rounded-3xl p-6 shadow-[10px_10px_0px_0px_#ccd5ae] md:shadow-[14px_14px_0px_0px_#ccd5ae] transition-all bg-grid-pattern group"
      >
        {/* Tombol Close Pojok Kanan Atas */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 border-2 border-slate-900 bg-white p-1.5 rounded-xl text-slate-900 hover:bg-gsf-sand/40 hover:text-gsf-bronze active:translate-y-0.5 transition-all"
          aria-label="Close Modal"
        >
          <FaXmark className="text-sm stroke-[3]" />
        </button>

        {/* Konten Internal Modal */}
        <div className="text-center space-y-4 pt-4">
          {/* Ikon Folder Mini */}
          <div className="mx-auto w-12 h-12 border-2 border-slate-900 bg-gsf-cream/40 text-gsf-bronze rounded-2xl flex items-center justify-center text-xl shadow-[3px_3px_0px_0px_#faedcd]">
            <FaFolderOpen />
          </div>

          {/* Judul & Badge Status */}
          <div className="space-y-1">
            <span className="inline-block text-[9px] font-mono font-black uppercase tracking-widest text-gsf-bronze bg-gsf-sand/40 border border-gsf-bronze/20 px-2.5 py-1 rounded-md">
              Documentation Pipeline
            </span>
            <h3 className="text-2xl font-black text-slate-900 tracking-tight leading-none pt-2">
              Case Study Coming Soon
            </h3>
          </div>

          {/* Pesan Kontekstual */}
          <p className="text-xs sm:text-sm text-slate-600 font-medium leading-relaxed max-w-xs mx-auto">
            The technical engineering breakdown for{" "}
            <span className="text-slate-900 font-bold underline decoration-gsf-bronze decoration-2">
              {projectTitle}
            </span>{" "}
            is currently being compiled into a production-grade architecture
            journal.
          </p>

          {/* Tombol Konfirmasi Penutup */}
          <div className="pt-2">
            <button
              onClick={onClose}
              className="w-full border-2 border-slate-900 bg-slate-900 py-2.5 font-bold text-xs uppercase tracking-wider text-white rounded-xl shadow-[3px_3px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_0px_#d4a373] active:translate-y-0"
            >
              Acknowledge & Close
            </button>
          </div>
        </div>

        {/* Dekorasi Kode Aksesori */}
        <div className="absolute bottom-2 left-4 font-mono text-[8px] text-slate-400 select-none">
          sys.status === "compiling"
        </div>
      </div>
    </div>
  );
}

export default ComingSoonModal;
